import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from './__root';

/**
 * `/email-accounts/$id/activity` is now a redirect, not a page — Activity
 * folded into a tab on `/email-accounts/$id` (`?tab=activity`; see
 * `features/email-accounts/detail/ActivityTab.tsx`). This route only exists
 * so a bookmarked/shared link to the old URL still lands correctly instead of
 * 404ing. Mirrors `routes/index.tsx`'s `beforeLoad` redirect pattern exactly:
 * `beforeLoad` runs ahead of the loader and component, so the throw
 * short-circuits the route render — `component` is never invoked at runtime
 * but TanStack Router still requires the prop, so it's a no-op.
 */
export const emailAccountActivityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/email-accounts/$id/activity',
  // Coerce to number so `params` matches `emailAccountDetailRoute`'s own
  // `parseParams` shape below — `redirect({ to, params })` expects the
  // TARGET route's parsed param types, not this route's raw string.
  parseParams: (params) => ({ id: Number(params.id) }),
  stringifyParams: (params) => ({ id: String(params.id) }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/email-accounts/$id',
      params,
      search: { ...search, tab: 'activity' },
      replace: true,
    });
  },
  component: () => null,
});
